import { Component, type ReactNode } from 'react';
import { Button } from '@/components/ui/Button';
import ErrorState from '@/components/ui/ErrorState/ErrorState';

interface PageErrorBoundaryProps {
  children: ReactNode;
  onHome: () => void;
}

interface PageErrorBoundaryState {
  failed: boolean;
}

/**
 * Keeps the app usable when one page fails to load (for example a module that has
 * no real backend yet): the header and menu stay, and the page shows a short
 * message instead of a blank screen. Keyed by the route in AppShell, so moving to
 * another page starts fresh.
 */
export default class PageErrorBoundary extends Component<PageErrorBoundaryProps, PageErrorBoundaryState> {
  state: PageErrorBoundaryState = { failed: false };

  static getDerivedStateFromError(): PageErrorBoundaryState {
    return { failed: true };
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="py-4">
        <ErrorState
          title="This section isn't available yet"
          message="Please try another part of NovaBank."
        />
        <div className="text-center">
          <Button onClick={this.props.onHome}>Back to Home</Button>
        </div>
      </div>
    );
  }
}
